import React, { useState, useEffect } from 'react'
import { Row, Col, Button, Image, Divider, Tag, Typography } from 'antd';
import { Avatar, Card } from 'antd';
import { UserOutlined, MailOutlined, PhoneOutlined, FormOutlined } from '@ant-design/icons';
import { API, IMAGE_API, usuario } from '../../resources';
import Loading from '../../loading';
import PerfilEdit from './perfilEdit';
import Configuration from './configuration';
import Android from "../../assets/droid.png";
import QR from "../../assets/frame.png";

export default function Perfil() {

    const [profileData, setProfileData] = useState([]);
    const [editing, setEditing] = useState(false)
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => { getProfileData() }, [])
    useEffect(() => { getProfileData() }, [editing])

    const getProfileData = () => {
        fetch(API + 'userByMail/' + usuario.email)
            .then(response => response.json())
            .then(data => {
                setProfileData(data[0]);
                setIsLoading(false);
            });
    }

    const editPerfil = (p) => {
        p.horarios.forEach((h) => { h.sucursal = h.sucursal._id })
        setEditing(true);
    }

    const MiniCard = ({ universidad, carrera, cedula = '' }) => (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 12, textAlign: 'left' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '30%', borderBottom: 'solid 2px #f5f6f8' }}><div className='desc'>Universidad:</div><div>{universidad}</div></div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '30%', borderBottom: 'solid 2px #f5f6f8' }}><div className='desc'>Carrera:</div><div>{carrera}</div></div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '30%', borderBottom: 'solid 2px #f5f6f8' }}><div className='desc'>Cedula:</div><div>{cedula}</div></div>
        </div>
    )

    const DetailsProfile = () => (
        <div>
            <Row gutter={[24, 24]}>
                <Col xs={24} md={8} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                    {profileData.avatar.length > 9
                        ? <Image style={{ borderRadius: '50%', objectFit: 'cover' }} width={160} height={160} src={IMAGE_API + profileData.avatar} alt='medic-profile-pic' />
                        : <Avatar size={160} icon={<UserOutlined />} className='btnIconCentered' />
                    }
                    <div style={{ height: 16 }} />
                    <p className='nombre'>{profileData.name}</p>
                    {profileData.especialidad && <Tag color="purple" style={{ marginBottom: 4 }}>{profileData.especialidad}</Tag>}
                    <Tag color="blue" style={{ marginBottom: 8 }}>{profileData.rol}</Tag>
                    <Divider style={{ margin: '12px 0' }} />
                    <div style={{ textAlign: 'center', width: '100%' }}>
                        <p className='datos'><MailOutlined style={{ marginRight: 8 }} />{profileData.email}</p>
                        <p className='datos'><PhoneOutlined style={{ marginRight: 8 }} />{profileData.telefono}</p>
                    </div>
                </Col>

                <Col xs={24} md={8}>
                    <Card title='Horarios' style={{ borderRadius: 12, height: '100%' }}>
                        {profileData.horarios.map((h, i) => (
                            <Card.Grid key={i} style={{ width: '100%' }}>
                                <Row align="middle" gutter={16}>
                                    <Col flex="80px" style={{ display: 'flex', justifyContent: 'center' }}>
                                        <img width={56} src={h.sucursal.logo ? IMAGE_API + h.sucursal.logo : IMAGE_API + 'noimg.jpg'} alt="Logo" style={{ objectFit: 'contain' }} />
                                    </Col>
                                    <Col flex="auto">
                                        <p className='datos' style={{ margin: 0 }}>{h.sucursal.nombre}</p>
                                        <p className='subdesc' style={{ margin: 0 }}>{h.horario}</p>
                                    </Col>
                                </Row>
                            </Card.Grid>
                        ))}
                    </Card>
                </Col>

                <Col xs={24} md={8}>
                    <Card title='Universidades' style={{ borderRadius: 12, height: '100%' }}>
                        {profileData.universidades && profileData.universidades.map((u, i) => (
                            <MiniCard key={i} {...u} />
                        ))}
                    </Card>
                </Col>
            </Row>

            <div style={{ marginTop: 24 }}>
                <Configuration id_usuario={usuario._id} correo={usuario.email} />
            </div>
        </div>
    )

    return (
        <div style={{ padding: '24px', background: '#f5f7fa', minHeight: '100vh' }}>
            <Card
                title={
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center', gap: '12px' }}>
                        <div style={{ padding: '10px', background: '#e6f4ff', borderRadius: '10px', display: 'flex' }}>
                            <UserOutlined style={{ fontSize: '24px', color: '#1677ff' }} />
                        </div>
                        <Typography.Title level={3} style={{ margin: 0, color: '#1f1f1f' }}>Perfil</Typography.Title>
                    </div>
                }
                extra={
                    !editing && !isLoading &&
                    <Button onClick={() => editPerfil(profileData)} type='primary' shape='circle' icon={<FormOutlined />} className='btnIconCentered' />
                }
                bordered={false}
                style={{ borderRadius: '16px', boxShadow: '0 4px 24px -8px rgba(0,0,0,0.05)' }}
            >
                {isLoading
                    ? <Loading />
                    : editing
                        ? <>
                            <PerfilEdit perfil={profileData} setEditing={setEditing} />
                            <Button style={{ marginTop: 12 }} onClick={() => setEditing(false)}>Cancelar</Button>
                          </>
                        : <DetailsProfile />
                }
            </Card>

            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 16, marginTop: 24 }}>
                <div className='lcolumna' style={{ alignItems: 'center' }}>
                    <img width={120} src={Android} alt="recreamedLogo" />
                    <a href='https://api.recreamed.com/images/recreamedMobile.apk'>Descargar aplicación</a>
                </div>
                <Image width={120} src={QR} />
            </div>
        </div>
    )
}
